<template>
  <div
    :class="className"
    v-on="listeners"
  >
    <!-- @slot tag内容 -->
    <slot />
    <ten-icon
      icon="clear"
      v-if="closable"
      class="ten-tag__close"
      @click="onClose"
    />
  </div>
</template>

<script>
import TenIcon from '../icon';

const name = 'ten-tag';
export default {
  name,
  components: {
    TenIcon,
  },
  props: {
    /**
     * 是否可关闭
     */
    closable: Boolean,
  },
  computed: {
    className() {
      return [
        'ten-tag',
        {
          'ten-tag--closable': this.closable,
        },
      ];
    },
    listeners() {
      const { close, ...otherEvent } = this.$listeners;
      return { ...otherEvent };
    },
  },
  methods: {
    onClose(e) {
      e.stopPropagation();
      /**
       * 关闭tag的回调
       */
      this.$emit('close');
    },
  },
};
</script>
